// A (possibly faster) way to get the current timestamp as an integer.
export default Date.now || function() {
  return new Date().getTime();
};



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/now.js
// module id = 248
// module chunks = 106